/**
 * Realtime → activity cache. A `card.*` frame names the card as `{ kind, id }`
 * and a `comment.*` frame as `{ deliverableKind, deliverableId }`; either one
 * means the card's log has a new row. A frame whose payload can't be read
 * invalidates the whole family instead of guessing — over-invalidating a log
 * nobody has open is free, missing a live one is the bug.
 */

import type { QueryClient } from '@tanstack/react-query'

import { CARD_ACTIVITY_QUERY_KEY, CARD_ACTIVITY_QUERY_ROOT } from './use-card-activity'

function str(v: unknown): string | null {
  return typeof v === 'string' && v.length > 0 ? v : null
}

export function invalidateCardActivityFromFrame(queryClient: QueryClient, payload: unknown): void {
  const p =
    typeof payload === 'object' && payload !== null ? (payload as Record<string, unknown>) : null
  // Check the comment shape first: a comment frame's own `id` is the COMMENT's.
  const kind = str(p?.deliverableKind) ?? str(p?.kind)
  const id = str(p?.deliverableId) ?? str(p?.id)
  if (!kind || !id) {
    queryClient.invalidateQueries({ queryKey: CARD_ACTIVITY_QUERY_ROOT })
    return
  }
  queryClient.invalidateQueries({
    queryKey: CARD_ACTIVITY_QUERY_KEY(kind as Parameters<typeof CARD_ACTIVITY_QUERY_KEY>[0], id),
  })
}
